import { render, staticRenderFns } from "./moreIndustry.vue?vue&type=template&id=9603efea&scoped=true&"
import script from "./moreIndustry.vue?vue&type=script&lang=js&"
export * from "./moreIndustry.vue?vue&type=script&lang=js&"
import style0 from "./moreIndustry.vue?vue&type=style&index=0&id=9603efea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9603efea",
  null
  
)

export default component.exports